<template>
  <div class="room-summary">
    <span class="room-summary__title">{{ room.name.it }}</span>
    <div class="room-summary__bed" v-if="room.bed_options">
      <vb-icon class="room-summary__icon" :name="'doublebed'" :color="sass('gray-900')" :size="13" />
      <span>{{ format_beds(room.bed_options) }}</span>
    </div>
    <span
      v-if="room_availability.text"
      :class="'room-summary__availability ' + room_availability.class"
    >{{ room_availability.text }}</span>
    <ul class="room-summary__facilities" v-if="room.facilities.length">
      <li v-for="(facility, facility_index) in room.facilities" :key="_uid+'_facility_'+facility_index">
        <span v-if="facility_index < 8">{{ get_room_facilities(facility).label }}</span>
      </li>
    </ul>
    <span
      class="room-summary__show"
      v-if="room.facilities.length > 8"
      v-b-modal="'modal_room_' + room.id">vedi tutti</span>
  </div>
</template>

<script>
import { format_beds } from '@bookingv3/utilities'
import { get_room_facilities } from '@bookingv3/resources'

export default {
  name: 'room-summary',

  components: {
  },

  props: {
    room: Object
  },

  data() {
    return {
    }
  },

  computed: {

    // ritorna classe e copy del numero di camere disponibili
    room_availability() {
      const product = this.room.products[0],
            count = product ? product.number_available_at_this_price : 0

      return {
        class: count === 1 ? 'room-summary__availability--alert' : '',
        text: count > 0 ? count + (count > 1 ? ' camere disponibili' : ' camera disponibile') : ''
      }
    }

  },

  created() {
    this.format_beds = format_beds
    this.get_room_facilities = get_room_facilities
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .room-summary {
    position: sticky;
    top: $grid-gutter-width/2;
    padding-left: $grid-gutter-width/2;
    padding-right: $grid-gutter-width;

    &__title {
      margin-bottom: 5px;
      display: block;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
    }

    &__icon {
      margin-top: 3px;
      margin-right: 5px;
    }

    &__bed {
      color: $gray-900;
      display: flex;
      align-items: flex-start;
      font-size: $font-size-md;
      line-height: normal;
    }

    &__availability {
      display: flex;
      align-items: center;
      font-size: $font-size-md;
      margin-top: 10px;

      &:before {
        content: '';
        width: 6px;
        height: 6px;
        background-color: $vb-body-color;
        display: inline-block;
        border-radius: 100%;
        margin-right: 5px;
        margin-top: 2px;
      }

      &--alert {
        color: $danger;

        &:before {
          background-color: $danger;
        }
      }
    }

    &__facilities {
      padding: 0;
      margin: 10px 0 0;

      li {
        list-style: none;
        font-size: $font-size-sm;
        display: inline-block;
        vertical-align: middle;
        margin: 2px;
        color: $primary;
        background-color: rgba(255,255,255, .8);
        padding: 2px 5px;
        border-radius: 5px;

        &:empty {
          display: none;
        }
      }
    }

    &__show {
      color: $info;
      text-decoration: underline;
      font-size: $font-size-sm;
      cursor: pointer;
      display: inline-block;
      margin-top: 10px;
      margin-left: 5px;
    }
  }

</style>